module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hello":"hello world!666"},"ja":{"hello":"こんにちは、世界！666"}}')
  delete Component.options._Ctor
}
